import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const ImageIcon = ({size = {width: 32, height: 40}}: Props) => {
    return (
        <svg width={size.width} height={size.height} viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.59518 10.3571L10.4929 1.57645C10.8672 1.20709 11.3718 1 11.8977 1H28C29.6569 1 31 2.34315 31 4V36C31 37.6569 29.6569 39 28 39H4C2.34315 39 1 37.6569 1 36V11.7806C1 11.2456 1.21437 10.7329 1.59518 10.3571Z'
                stroke='#338AFF'
                strokeWidth='2'
            />
            <path d='M11 2V11C11 11.5523 10.5523 12 10 12H2' stroke='#338AFF' strokeWidth='2' />
            <path
                d='M23.5903 32H8.48957C8.28551 32 8.1674 31.7687 8.28705 31.6034L12.428 25.8823C12.5077 25.7722 12.6608 25.746 12.7726 25.8232L14.7942 27.2197C14.8294 27.244 14.8775 27.2363 14.9034 27.2023L18.6172 22.3158C18.7284 22.1693 18.9544 22.1891 19.0385 22.3527L23.8126 31.6357C23.8982 31.802 23.7774 32 23.5903 32Z'
                stroke='#338AFF'
                strokeWidth='2'
            />
            <circle cx='11' cy='21' r='2' stroke='#338AFF' strokeWidth='2' />
        </svg>
    );
};
